const SERVICES = [
    { label: "Recruitment", href: "#recruitment" },
    { label: "Employer Solutions", href: "#recruitment" },
    { label: "Jobs", href: "/jobs" },
    { label: "Global Mobility", href: "#global-mobility" },
    { label: "Study Abroad", href: "#study-abroad" },
    { label: "Scholarships", href: "#scholarships" },
    { label: "Visa Assistance", href: "#global-mobility" },
    { label: "Hajj & Umrah", href: "#global-mobility" },
];

const COMPANY = [
    { label: "About", href: "#about" },
    { label: "Contact", href: "#contact" },
    { label: "Hire Talent", href: "#contact" },
    { label: "Find Jobs", href: "/jobs" },
];

export const Footer = () => (
    <footer data-testid="site-footer" className="bg-night text-ivory/60">
        <div className="mx-auto max-w-7xl px-6 py-16 lg:px-10 lg:py-20">
            <div className="grid gap-12 lg:grid-cols-12">
                <div className="lg:col-span-5">
                    <a href="#home" data-testid="footer-logo-link" className="flex items-center gap-3 text-ivory">
                        <span className="flex h-11 w-11 items-center justify-center bg-forest font-serif text-[13px] font-semibold tracking-widest text-ivory">
                            AGL
                        </span>
                        <span className="font-serif text-lg font-semibold tracking-tight">
                            Afrinexa Global
                        </span>
                    </a>
                    <p className="mt-6 max-w-sm text-sm leading-relaxed">
                        Connecting people, talent and opportunities across borders — international
                        recruitment, manpower solutions, global mobility, study abroad and visa assistance.
                    </p>
                    <div className="mt-6 space-y-1 text-sm">
                        <a
                            href="mailto:contact@afrinexaglobal.org"
                            data-testid="footer-email-contact-link"
                            className="block transition-colors hover:text-champagne"
                        >
                            contact@afrinexaglobal.org
                        </a>
                        <a
                            href="mailto:info@afrinexaglobal.org"
                            data-testid="footer-email-info-link"
                            className="block transition-colors hover:text-champagne"
                        >
                            info@afrinexaglobal.org
                        </a>
                    </div>
                </div>

                <nav aria-label="Services" className="lg:col-span-4">
                    <p className="text-[11px] font-medium uppercase tracking-[0.3em] text-ivory/40">
                        Services
                    </p>
                    <ul className="mt-6 grid grid-cols-2 gap-x-6 gap-y-3 text-sm">
                        {SERVICES.map((link) => (
                            <li key={link.label}>
                                <a
                                    href={link.href}
                                    data-testid={`footer-service-${link.label.toLowerCase().replace(/[^a-z]+/g, "-")}-link`}
                                    className="transition-colors hover:text-champagne"
                                >
                                    {link.label}
                                </a>
                            </li>
                        ))}
                    </ul>
                </nav>

                <nav aria-label="Company" className="lg:col-span-3">
                    <p className="text-[11px] font-medium uppercase tracking-[0.3em] text-ivory/40">
                        Company
                    </p>
                    <ul className="mt-6 space-y-3 text-sm">
                        {COMPANY.map((link) => (
                            <li key={link.label}>
                                <a
                                    href={link.href}
                                    data-testid={`footer-company-${link.label.toLowerCase().replace(/[^a-z]+/g, "-")}-link`}
                                    className="transition-colors hover:text-champagne"
                                >
                                    {link.label}
                                </a>
                            </li>
                        ))}
                    </ul>
                </nav>
            </div>

            <div className="mt-16 flex flex-col gap-6 border-t border-ivory/10 pt-8 text-xs md:flex-row md:items-center md:justify-between">
                <p data-testid="footer-legal-line">
                    © 2026 Afrinexa Global Ltd — CAC RC 8710821 · Afrinexa Global LLC
                </p>
                <div className="flex gap-6">
                    <a
                        href="#"
                        data-testid="footer-privacy-link"
                        className="transition-colors hover:text-champagne"
                    >
                        Privacy Policy
                    </a>
                    <a
                        href="#"
                        data-testid="footer-terms-link"
                        className="transition-colors hover:text-champagne"
                    >
                        Terms
                    </a>
                    <a
                        href="#"
                        data-testid="footer-disclaimer-link"
                        className="transition-colors hover:text-champagne"
                    >
                        Disclaimer
                    </a>
                </div>
            </div>
        </div>
    </footer>
);
